import Navbar from './components/Navbar.jsx';
import StickyCTA from './components/StickyCTA.jsx';
import NoiseOverlay from './components/shared/NoiseOverlay.jsx';
import Hero from './components/Hero.jsx';
import Services from './components/Services.jsx';
import Portfolio from './components/Portfolio.jsx';
import Team from './components/Team.jsx';
import Testimonials from './components/Testimonials.jsx';
import TechStack from './components/TechStack.jsx';
import ContactForm from './components/ContactForm.jsx';
import Footer from './components/Footer.jsx';

export default function App() {
  return (
    <div id="top" className="relative min-h-screen overflow-x-clip">
      <NoiseOverlay />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Portfolio />
        <Team />
        <Testimonials />
        <TechStack />
        <ContactForm />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
